import {
  ComingNomenclatureAdjustmentDetail,
  ComingNomenclatureAdjustmentDetailRequest,
  ComingNomenclatureAdjustmentInfoItem,
  ComingNomenclatureAdjustmentItem,
} from 'bus/comingNomenclatureAdjustment/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class ComingNomenclatureAdjustmentApi {
  async getComingNomenclatureAdjustment(data: PayloadRequest) {
    return await $axios
      .get<ComingNomenclatureAdjustmentItem>(`/v1/comingNomenclatureAdjustment/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createComingNomenclatureAdjustment(data: ComingNomenclatureAdjustmentItem) {
    return await $axios
      .post('/v1/comingNomenclatureAdjustment/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editComingNomenclatureAdjustment(data: ComingNomenclatureAdjustmentItem) {
    return await $axios
      .put(`/v1/comingNomenclatureAdjustment/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteComingNomenclatureAdjustment(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/comingNomenclatureAdjustment/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getComingNomenclatureAdjustmentInfo(data: PayloadRequest) {
    return await $axios
      .get<ComingNomenclatureAdjustmentInfoItem>(`/v1/comingNomenclatureAdjustment/${data.id}/info`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  //detail
  async getComingNomenclatureAdjustmentDetailList(data: PayloadRequest) {
    return await $axios
      .get<ComingNomenclatureAdjustmentDetail[]>(`/v1/comingNomenclatureAdjustment/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getComingNomenclatureAdjustmentDetailOne(data: PayloadRequest) {
    return await $axios
      .get<ComingNomenclatureAdjustmentDetail>(`/v1/comingNomenclatureAdjustment/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createComingNomenclatureAdjustmentDetail(data: ComingNomenclatureAdjustmentDetailRequest) {
    return await $axios
      .post(`/v1/comingNomenclatureAdjustment/${data.adjustmentId}/details`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editComingNomenclatureAdjustmentDetail(data: ComingNomenclatureAdjustmentDetailRequest) {
    return await $axios
      .put(`/v1/comingNomenclatureAdjustment/details/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteComingNomenclatureAdjustmentDetail(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/comingNomenclatureAdjustment/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
